import React from "react";
import { connect } from "react-redux";
import { useStyles } from "./styles";
import {
  setFrontratingAnsweres,
  resetFrontratingAnsweres,
} from "../../../../redux/frontWebRating/actions";
import { useIdleTimer } from "react-idle-timer";
import { useIntl } from "react-intl";
import { saveDetails } from "../../../apiHelpers/saveDetails";
import { useHistory } from "react-router-dom";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { Box, Divider, Grid } from "@mui/material";
import {
  resolveCompanyId,
  getAlphigaFollowUpConfig,
  getAlphigaFollowUpQuestions,
  ALPHIGA_GATE_STATE_KEY,
} from "../../../constants/alphigaCompanies";

function EmployeDetail(props) {
  const intl = useIntl();
  const classes = useStyles();
  const history = useHistory();
  const [cookies, setCookie] = useCookies(["rating"]);

  const {
    webRatingAnsweres,
    setFrontratingAnsweres_,
    showAlphigaQ,
    handleYes,
    handleNo,
  } = props;

  const companyId = resolveCompanyId(props.webRatingData);
  const followUpConfig = getAlphigaFollowUpConfig(companyId);
  const followUpSectionIntroId = followUpConfig?.followUpSectionIntroId;
  const followUpQuestions = getAlphigaFollowUpQuestions(companyId);

  const { getRemainingTime } = useIdleTimer({
    timeout: 1000 * 20,
    onIdle: async () => {
      getRemainingTime();

      let ratingCookie = cookies.rating;
      if (
        ratingCookie?.location !== props.webRatingAnsweres.location_id ||
        localStorage.getItem("is_frequent_rating")
      ) {
        const response = await saveDetails({
          ...props.webRatingAnsweres,
          page: 2,
          dropout_page: "p2",
        });
        if (response && response?.data?.metaData) {
          setCookie(
            "rating",
            {
              rating: "submited",
              location: response.data.metaData.location_id,
            },
            { path: "/", maxAge: 86400 },
          );
          props.resetFrontratingAnsweres_();
          history.push("/thankYou");
        } else {
          toast.error(response?.message);
          history.push("/frontRating");
        }
      } else {
        toast.error(
          intl.formatMessage({ id: "you-have-already-submitted-rating" }),
        );
      }
    },

    debounce: 500,
  });

  return (
    <Box
      style={{ padding: "2rem 1rem 1rem 1rem" }}
      className={classes.boxContainer}
    >
      <Grid container className={classes.container}>
        <Grid item xs={10} className={classes.qTitle}>
          <p className="mb-0">
            {intl.formatMessage({
              id: "did-you-buy-medicine-in-the-pharmacy-today",
            })}
          </p>
        </Grid>
        <Grid item xs={2} className={classes.actionContainer}>
          <Box
            className={classes.action}
            onClick={handleNo}
            style={{
              background:
                webRatingAnsweres?.[ALPHIGA_GATE_STATE_KEY] === "No" && "red",
            }}
          >
            <h5
              className={`${classes.actionText}`}
              style={{
                color:
                  webRatingAnsweres?.[ALPHIGA_GATE_STATE_KEY] === "No" &&
                  "white",
              }}
            >
              {intl.formatMessage({ id: "no" })}
            </h5>
          </Box>
          <Box
            className={classes.action}
            onClick={handleYes}
            style={{
              background:
                webRatingAnsweres?.[ALPHIGA_GATE_STATE_KEY] === "Yes" &&
                "green",
            }}
          >
            <h5
              className={`${classes.actionText}`}
              style={{
                color:
                  webRatingAnsweres?.[ALPHIGA_GATE_STATE_KEY] === "Yes" &&
                  "white",
              }}
            >
              {intl.formatMessage({ id: "yes" })}
            </h5>
          </Box>
        </Grid>
      </Grid>
      <Divider variant="fullWidth" className={classes.divider} />

      {showAlphigaQ === "Yes" ? (
        <>
          {followUpSectionIntroId ? (
            <Grid container className={classes.container}>
              <Grid item xs={10} className={classes.qTitle}>
                <p className="mb-0">
                  <strong>
                    {intl.formatMessage({ id: followUpSectionIntroId })}
                  </strong>
                </p>
              </Grid>
            </Grid>
          ) : null}
          {followUpQuestions.map(({ messageId, stateKey }) => (
            <Grid container className={classes.container} key={stateKey}>
              <Grid item xs={10} className={classes.qTitle}>
                <p className="mb-0 ml-4">
                  {intl.formatMessage({ id: messageId })}
                </p>
              </Grid>
              <Grid item xs={2} className={classes.actionContainer}>
                <Box
                  className={`${
                    webRatingAnsweres?.[stateKey] === "No"
                      ? classes.actionFalse
                      : ""
                  } ${classes.action}`}
                  onClick={() => {
                    setFrontratingAnsweres_({ key: stateKey, value: "No" });
                  }}
                >
                  <h5
                    style={{
                      color: webRatingAnsweres?.[stateKey] === "No" && "white",
                    }}
                    className={classes.actionText}
                  >
                    {intl.formatMessage({ id: "no" })}
                  </h5>
                </Box>
                <Box
                  className={`${
                    webRatingAnsweres?.[stateKey] === "Yes"
                      ? classes.actionTrue
                      : ""
                  } ${classes.action}`}
                  onClick={() => {
                    setFrontratingAnsweres_({ key: stateKey, value: "Yes" });
                  }}
                >
                  <h5
                    style={{
                      color: webRatingAnsweres?.[stateKey] === "Yes" && "white",
                    }}
                    className={classes.actionText}
                  >
                    {intl.formatMessage({ id: "yes" })}
                  </h5>
                </Box>
              </Grid>
            </Grid>
          ))}
        </>
      ) : null}
    </Box>
  );
}

const mapStateToProps = (state) => {
  return {
    webRatingData: state.frontWebRatingDataReducer.webRatingData,
    webRatingAnsweres: state.frontWebRatingDataReducer.webRatingAnsweres,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFrontratingAnsweres_: (data) => dispatch(setFrontratingAnsweres(data)),
    resetFrontratingAnsweres_: () => dispatch(resetFrontratingAnsweres()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeDetail);
